import React from "react";
import PropTypes from "prop-types";

/**
 * Icons that can easily be reused in all the project
 */
const CancelIcon = ({ size, color, marginRight, ...props }) => (
  <svg
    x="0px"
    y="0px"
    viewBox="0 0 10 10"
    xmlSpace="preserve"
    width={`${size}`}
    height={`${size}`}
    style={{ marginRight }}
    {...props}
  >
    <path
      d="M10 1.00714L8.99286 0L5 3.99286L1.00714 0L0 1.00714L3.99286 5L0 8.99286L1.00714 10L5 6.00714L8.99286 10L10 8.99286L6.00714 5L10 1.00714Z"
      fill={color}
    />
  </svg>
);

CancelIcon.propTypes = {
  /**
   * What background color to use
   */
  color: PropTypes.string,
  /**
   * How large should the icon be?
   */
  size: PropTypes.number,
  /**
   * Margin at the right of the icon
   */
  marginRight: PropTypes.number
};

CancelIcon.defaultProps = {
  color: "#ffffff",
  size: 20,
  marginRight: 0
};

export default CancelIcon;
